export default "__VITE_ASSET__C0K1ub7D__"